export interface CurrentUser {
    id?: string;
    email?: string;
    display_name?: string;
    entra_oid?: string;
    company_id?: string | null;
    company_role?: string | null;
    company?: {
        id?: string | null;
        [key: string]: unknown;
    } | null;
    profile?: {
        profile_photo_url?: string;
        [key: string]: unknown;
    } | null;
    [key: string]: unknown;
}

export interface CurrentUserResult {
    ok: boolean;
    status: number;
    user: CurrentUser | null;
}

const CACHE_TTL_MS = 30_000;

let cachedResult: CurrentUserResult | null = null;
let cachedAt = 0;
let inFlightRequest: Promise<CurrentUserResult> | null = null;

export function clearCurrentUserCache() {
    cachedResult = null;
    cachedAt = 0;
    inFlightRequest = null;
}

export async function getCurrentUser(options: { idToken?: string; force?: boolean } = {}): Promise<CurrentUserResult> {
    const now = Date.now();

    if (!options.force && cachedResult && now - cachedAt < CACHE_TTL_MS) {
        return cachedResult;
    }

    if (!options.force && inFlightRequest) {
        return inFlightRequest;
    }

    inFlightRequest = fetch("/auth/me", {
        headers: options.idToken ? { Authorization: `Bearer ${options.idToken}` } : {},
        credentials: "same-origin"
    })
        .then(async response => {
            const result: CurrentUserResult = {
                ok: response.ok,
                status: response.status,
                user: response.ok ? ((await response.json()) as CurrentUser) : null
            };

            if (response.ok) {
                cachedResult = result;
                cachedAt = Date.now();
            }

            return result;
        })
        .finally(() => {
            inFlightRequest = null;
        });

    return inFlightRequest;
}
